/* 單獨列傳的登錄表：每條列傳一個檔，各自帶 list / chapters / maps */
// @ts-nocheck
import guanzhang from './guanzhang.ts';
import zhaoyun from './zhaoyun.ts';
import machao from './machao.ts';
import simayi from './simayi.ts';
import xiahouyuan from './xiahouyuan.ts';
import zhouyu from './zhouyu.ts';
import ganning from './ganning.ts';
import luxun from './luxun.ts';
import taishici from './taishici.ts';

export default [guanzhang, zhaoyun, machao, xiahouyuan, simayi, zhouyu, ganning, luxun, taishici];
